/**
 * Whether a path belongs to the public web app (end users) rather than the CMS.
 * Both live under the Dash layout, so layout-level styling has to tell them apart by path.
 */
export function isWebAppPath(path: string): boolean {
  return path.startsWith('/web')
    || path.startsWith('/auth/web')
    || path.startsWith('/wallet/');
}

export default isWebAppPath;
